import React, { Component } from 'react'
import {
    Col, Row, Button, Grid, Pagination
  } from '@sketchpixy/rubix'
  import {
    DEFAULT_DATE_FORMAT,
  } from '../utils'
  import moment from 'moment';
  import LoadingContainer from "../components/LoadingContainer";
  import NotificationSystem from 'react-notification-system';
  import {FIELD_STATUSES} from '../utils'
  
  
class ViewCorrected extends Component {
    constructor (props) {
      super(props)
        sessionStorage.removeItem('questionState');
        sessionStorage.removeItem('patient');
        sessionStorage.removeItem('currentDbq');
        sessionStorage.removeItem('page');
        sessionStorage.removeItem("current")
        sessionStorage.removeItem("src")
        sessionStorage.removeItem("note")
        sessionStorage.removeItem("pDoc")
        sessionStorage.removeItem("correctedFileURL")
        sessionStorage.removeItem("signedFileURL")
        sessionStorage.removeItem("highlightedFileURL")
        sessionStorage.removeItem("signedFileName")
        sessionStorage.removeItem("correctedFileName")


      this.state = {
        correctedDbqRecords: sessionStorage.getItem("correctedDbqRecords") ? JSON.parse(sessionStorage.getItem("correctedDbqRecords")) : [],
        showSpinner: false,
        pageSize : 20,
        pageNumber: 1,
        start: 0
      }
    }
  
    componentDidMount() {
      this._notificationSystem = this.refs.notificationSystem
      let makeCall = this.props && this.props.location && this.props.location.isSignAgain ? false : true
      makeCall && this.loadCorrectedRecords() // same as Sidebar
    }
    loadCorrectedRecords = () => {
      let token = localStorage.getItem('login_token');
      let headers = {"Content-Type": "application/json"};
      headers["Authorization"] = `Bearer ${token}`
      fetch(process.env.API_URL+"/patients/corrected/count", {headers})
      .then(response => response.json())
      .then(data => {    
          sessionStorage.setItem("reviewBadge", data.correctedDbqRecords ? data.correctedDbqRecords.length : 0)
          sessionStorage.setItem("correctedDbqRecords", data.correctedDbqRecords ? JSON.stringify(data.correctedDbqRecords) : null)
          this.setState({correctedDbqRecords: data.correctedDbqRecords})
      })
      .catch((error) => {
          this.setState({showSpinner: false})
          console.error('Error:', error);
      });
    }

    submitClick = (link , pDoc) => {
      let recordsLocal = sessionStorage.getItem("correctedDbqRecords") ? JSON.parse(sessionStorage.getItem("correctedDbqRecords")) : []
      let found = false
      for (let rec of recordsLocal) {
        if (rec.dbqId === pDoc.dbqId) {
          found = true
          break
        }
      }
      if (found) {
        const {history} = this.props
        sessionStorage.setItem("pDoc", JSON.stringify(pDoc))
        sessionStorage.setItem('src', "correct");
        history.push({pathname:link, pDoc})
      } else {
        this._addNotification("It seems review is no longer needs for this DBQ", 'error', 'Error : ');
        setTimeout(function(){
          window.location.reload(1);
       }, 3000);
      }        
    }
    
    getPatientDocInfo = (reviewDbqs) => {
        let tableRow = []
        let i = 1;
        for (let pDoc of reviewDbqs) {
          i++
          // pDoc["patientId"] = patientId;
          // pDoc["dbqId"] = pDoc.id;
          // pDoc["patientName"] = patientName;
          // pDoc["dbqCount"] = dbqCount;
          tableRow.push(
            <tr className="tr-corrected-dbq" key={i} style={{fontSize: 16}}>
              <td></td>
              <td>{pDoc.patientName}</td>
              <td>{moment(pDoc.apptDt).format(DEFAULT_DATE_FORMAT)}</td>
              <td>{pDoc.dbqName}</td>
              <td>
              <Button
                  type='button'
                  bsStyle='primary'
                  className="btn"
                  style={{textTransform: 'none',fontSize: 15, color: 'white', height: '35px', borderRadius: '10px', boxShadow: '0px 5px 5px rgba(0, 0, 0, 0.25)'}}
                  onClick={this.submitClick.bind(this, `/admin/compare`, pDoc)}> Review
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" viewBox="0 0 24 24" fill='#fff' style={{marginLeft: 10, marginBottom: -3}}>
                    <path d="M13.025 1l-2.847 2.828 6.176 6.176h-16.354v3.992h16.354l-6.176 6.176 2.847 2.828 10.975-11z"/>
                    </svg>
              </Button>
              </td>
            </tr> 
          )
        }
        return tableRow
    }

    loadMoreRecords = (pageNumber) => {
      let start = (pageNumber-1)*this.state.pageSize
      this.setState({pageNumber, start})
    }

    _addNotification = (message, type, title) => {
      this._notificationSystem.clearNotifications()
      this._notificationSystem.addNotification({
          message,
          title: title,
          level: type,
          position: 'tr',
          autoDismiss: 10
      })

      if (type === 'error') {
          this.setState({
              emailError: {
                  status: FIELD_STATUSES.ERROR,
                  message: ''
              },
              passwordError: {
                  status: FIELD_STATUSES.ERROR,
                  message: ''
              }
          })
      }
  }
    render () {
        let { correctedDbqRecords, pageSize, pageNumber, start } = this.state
        
        let reviewCount = correctedDbqRecords && correctedDbqRecords.length ? correctedDbqRecords.length : 0
        correctedDbqRecords = correctedDbqRecords.slice(start, (pageNumber*pageSize))
      return (
        <div className={'home-containers show-with-ease'}>
          <NotificationSystem ref='notificationSystem'/>
            {
            this.state.showSpinner ? <LoadingContainer /> : "" 
            }
            <Row style={{paddingLeft: 25, paddingRight: 25}}>
            <h2 className='heading-main' style={{marginTop: 0, marginBottom:0}}>
                <strong>Review Required</strong>
            </h2>
            <h6 className='' style={{marginTop: 5, marginBottom:0, fontSize: 16}}>
                <strong>The following DBQs have been edited by VBG and require your review</strong>
            </h6>
                <Col sm={12} className="correct-dbq-panel animate__animated animate__fadeIn" style={{marginTop: "1%", padding: 0, display: correctedDbqRecords.length > 0 ? "block": "none"}}>
                    <table style={{width:'100%'}}>
                    <thead>
                        <tr className="tr-corrected-dbq" >
                        <th style={{width:'5%'}}></th>
                        <th style={{width:'30%'}}>Patient</th>
                        <th style={{width:'20%'}}>Appointment Date</th>
                        <th style={{width:'30%'}}>DBQ</th>
                        <th style={{width:'15%'}}></th>
                        </tr>
                    </thead>
                    {/* {
                        correctedDbqRecords && correctedDbqRecords.length > 0 && correctedDbqRecords.map((correctedRecord, index) => ( */}
                        <tbody>
                            {correctedDbqRecords && correctedDbqRecords.length > 0 && this.getPatientDocInfo(correctedDbqRecords)}
                        </tbody>
                        
                        {/* )) */}
                    {/* } */}
                    </table>
                </Col>
                    {!this.state.showSpinner && <Col className="correct-dbq-panel animate__animated animate__fadeIn" style={{marginTop: "1%", padding: 20, textAlign: 'center', display: correctedDbqRecords.length === 0 ? "block": "none"}}>
                    <h3 className='heading-main' style={{marginTop: 0, marginBottom:0}}>
                        No records found
                    </h3>
                </Col>}
            </Row>

            { correctedDbqRecords.length > 0 && 
              pageNumber && reviewCount > 20 ? <Grid>
                <Row>
                  <Col xs={12} style={{paddingTop: 12.5}}>
                    <h3 className='text-center'>
                      <Pagination
                        prev
                        next
                        first
                        last
                        ellipsis
                        boundaryLinks
                        bsSize='large'
                        maxButtons={4}
                        items={Math.ceil(reviewCount / pageSize)}
                        activePage={parseInt(pageNumber)}
                        onSelect={this.loadMoreRecords} />
                    </h3>
                  </Col>
                </Row>
              </Grid>
                : null
            }
        </div>
      )
    }
  }
  export default (ViewCorrected)